import React, { useContext, useState } from 'react';
import { GlobalContext } from '../../App';
import InvestigateSidebar from './InvestigateSidebar';
import AOIHistoryService from '../../services/AOIHistory';
import { message } from 'antd';

const InvestigateSidebarWrapper = ({ onHistoryLoaded, historyData }) => {
  const { investigatePolygon, setInvestigatePolygon } = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(false);

  const handleShowHistoricalData = (historicalData, polygon) => {
    console.log('Historical data clicked:', historicalData);
    console.log('Setting polygon in context:', polygon);
    
    // Set the polygon in GlobalContext for map to fly to
    setInvestigatePolygon(polygon);
    
    if (onHistoryLoaded) {
      // Extract the actual data if it's nested
      const dataToShow = historicalData?.data || historicalData;
      console.log('Passing to charts:', dataToShow);
      onHistoryLoaded({ data: dataToShow, polygon });
    }
  };

  const handleShowHistory = async () => {
    if (!investigatePolygon) return;

    setIsLoading(true);
    try {
      const data = await AOIHistoryService.getAOIHistory(investigatePolygon.geometry);
      
      // Create history item
      const historyItem = {
        id: Date.now(),
        polygon: investigatePolygon,
        data: data,
        analyzedAt: new Date().toISOString()
      };
      
      // Save to history in localStorage
      const existingHistory = JSON.parse(localStorage.getItem('InvestigateHistory') || '[]');
      const updatedHistory = [historyItem, ...existingHistory];
      localStorage.setItem('InvestigateHistory', JSON.stringify(updatedHistory));
      
      // Clear current polygon from GlobalContext
      setInvestigatePolygon(null);
      
      message.success('Analysis completed and saved to history');
      
      if (onHistoryLoaded) {
        onHistoryLoaded({ data, polygon: investigatePolygon });
      }
      
      // Trigger sidebar refresh
      window.dispatchEvent(new Event('investigateHistoryUpdated'));
    } catch (error) {
      message.error('Failed to analyze polygon');
      console.error('Error loading history:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <InvestigateSidebar 
      onShowHistory={handleShowHistory}
      isLoading={isLoading}
      onShowHistoricalData={handleShowHistoricalData}
      historyData={historyData}
    />
  );
};

export default InvestigateSidebarWrapper;
